module.exports = __webpack_public_path__ + "static/media/nongbeau_phone.f8ac476b.png";